<template>
  <div>
    <div
      v-if="isScrollView"
      class="flex flex-col gap-y-3 max-h-[140px] overflow-y-scroll scrollbar pr-2"
    >
      <template v-for="item in items" :key="item.id">
        <BaseCheckbox v-model="item.value" background-class="bg-white">
          <template #label>
            <div class="font-normal">
              {{ item.label }}
            </div>
          </template>
        </BaseCheckbox>
      </template>
    </div>

    <div v-else class="flex flex-col gap-y-3">
      <template
        v-for="item in items.slice(0, sidebarBottomListMaxLength)"
        :key="item.id"
      >
        <BaseCheckbox v-model="item.value" background-class="bg-white">
          <template #label>
            <div class="font-normal">
              {{ item.label }}
            </div>
          </template>
        </BaseCheckbox>
      </template>
      <template v-if="isExpanded && isHasExpansion">
        <template
          v-for="item in items.slice(sidebarBottomListMaxLength)"
          :key="item.id"
        >
          <BaseCheckbox v-model="item.value" background-class="bg-white">
            <template #label>
              <div class="font-normal">
                {{ item.label }}
              </div>
            </template>
          </BaseCheckbox>
        </template>
      </template>
      <BaseButton
        v-if="isHasExpansion && !isActiveItemHidden"
        look="none"
        justify="start"
        class="font-normal text-primary hover:text-primary-500 transition duration-150 ease-in-out font-normal !pl-0"
        @click="toggle"
      >
        {{ isExpanded ? $t('common.less') : $t('common.more') }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { sidebarBottomListMaxLength } from '~/models/menu'
import { CheckboxFilterItem } from '~/models/common'

interface PropsInterface {
  items: CheckboxFilterItem[]
  isScrollView?: boolean
  isActiveItemHidden?: boolean
}

const props = withDefaults(defineProps<PropsInterface>(), {
  isScrollView: false,
  isActiveItemHidden: false,
})

const isExpandedByUser = ref(false)

const isExpanded = computed(() => {
  return isExpandedByUser.value || props.isActiveItemHidden
})

const toggle = () => {
  isExpandedByUser.value = !isExpandedByUser.value
}

const isHasExpansion = computed(() => {
  return props.items && props.items.length > sidebarBottomListMaxLength
})
</script>

<style scoped>
.scrollbar::-webkit-scrollbar {
  width: 4px;
}

.scrollbar::-webkit-scrollbar-track {
  background: #d2d2d2;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: #909090;
  border-radius: 2px;
}
</style>
